export default __webpack_public_path__ + "static/media/image1.7313fc24.png";